import {
    ContentDetailInfoShell,
    ContentDetailThreeColLayout,
    DetailFilePanel,
    DetailKvListValue,
    DetailPanel,
    DetailKvTable,
    DetailSummaryPrintButton,
    KV_LIST_TYPES,
} from '../../../../components/detailLayout';
import React, {useEffect, useState} from "react";
import Th_title from "../../../../components/Th_title";
import {ContentCategory} from "../../../../constant/CodeSpecNum";
import ReadOnlyInputBasic from "../../../../components/input/ReadOnlyInputBasic";
import {getWorkPlan, removeWorkPlan, saveWorkPlan, updateWorkPlan} from "../../../../api/maintenance/WorkService";
import {connectedInfoRadio} from "../WorkCreate";
import SignContainer from "../../../../components/basic/SignContainer";
import {isEmpty} from "../../../../components/commonmethod/CommonMethod";
import SimmsDatePicker from "../../../../components/datepicker/SimmsDatePicker";
import {cn} from "../../../../shadCn/lib/utils";
import {dateOnChange} from "../../../../components/commonmethod/simmsDateMethod";
import dayjs from "dayjs";
import {inputOnChange} from "../../../../components/commonmethod/simmsInputMethod";
import SimmsTextArea from "../../../../components/input/SimmsTextArea";

function WorkPlanReport({id, work, assets, handler, statusNumericValue}){
    const [workPlan, setWorkPlan] = useState({});
    const [docs, setDocs] = useState([]);

    const remove = async () =>{
        const response = await removeWorkPlan({id : workPlan.id});
        if (response.status === 200) {
            setWorkPlan({});
            alert("작업계획서가 정상적으로 삭제되었습니다.");
        }
    }

    const cancel={
        url:"/maintenance/work"
    }

    useEffect(() =>{
        getWorkPlan(id).then((response) => {
            setWorkPlan(response.data)
        });
    }, [workPlan?.id])

    const create = async ()=>{
        const docFile=[]
        docs.forEach(each=>docFile.push(each.object))

        const data = {
            ...workPlan,
            work: {id : id}
        };

        await saveWorkPlan(data, docFile).then(response => {
            if(response.status === 200){
                setWorkPlan(response.data);
                alert("등록되었습니다.")
            }
        });
    }

    const update = async ()=>{
        const data = {
            ...workPlan,
            work: {id : id}
        };

        await updateWorkPlan(data).then(response => {
            if(response.status === 200){
                alert("수정되었습니다.")
            }
        });
    }

    const summaryMeta = [
        work.workCode?.name && `코드 ${work.workCode.name}`,
        work.requester?.name && `요청 ${work.requester.name}`,
    ].filter(Boolean).join(" · ");

    const requestInfoPanel = (
        <DetailPanel title={"작업요청정보"}>
            <DetailKvTable>
                <tbody>
                    <tr className="asset-detail-kv-row--auto">
                        <Th_title title={"자산목록"} colspan={3} className="fieldset-td relative align-top">
                            <DetailKvListValue items={assets} listType={KV_LIST_TYPES.asset} />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"작업연계정보"} colspan={3} className="fieldset-td relative align-top">
                            <ReadOnlyInputBasic target={"connectedInfo"} value={connectedInfoRadio.find(each => each.value === work.connectedInfo)?.text} />
                        </Th_title>
                    </tr>
                    {
                        work?.connectedId && work?.connectedInfo && (!isEmpty(work.service) || !isEmpty(work.inspect) || !isEmpty(work.incident)) ?
                        <tr>
                            <Th_title title={"연계정보"} colspan={3} className="fieldset-td relative align-top">
                                <div>제목 : {work.connectedInfo === ContentCategory.SERVICE_REQUEST ? work.service.title : work.connectedInfo === ContentCategory.INSPECTION ? work.inspect.title : work.connectedInfo === ContentCategory.INCIDENT ? work.incident.title : ""}</div>
                                <div>등록일 : {work.connectedInfo === ContentCategory.SERVICE_REQUEST ? work.service.createdAt : work.connectedInfo === ContentCategory.INSPECTION ? work.inspect.createdAt : work.connectedInfo === ContentCategory.INCIDENT ? work.incident.createdAt : ""}</div>
                                <div>수정일 : {work.connectedInfo === ContentCategory.SERVICE_REQUEST ? work.service.updatedAt : work.connectedInfo === ContentCategory.INSPECTION ? work.inspect.updatedAt : work.connectedInfo === ContentCategory.INCIDENT ? work.incident.updatedAt : ""}</div>
                            </Th_title>
                        </tr> :
                        <tr>
                            <Th_title title={"연계정보"} colspan={3} className="fieldset-td relative align-top">
                                <div>삭제된 정보입니다.</div>
                            </Th_title>
                        </tr>
                    }
                    <tr>
                            <Th_title title={"등록일시"} colspan={1} className="fieldset-td">
                                <ReadOnlyInputBasic target={"createdAt"} value={work.createdAt} />
                            </Th_title>
                            <Th_title title={"등록자"} colspan={1} className="fieldset-td">
                                <ReadOnlyInputBasic target={"createdBy"} value={work.createdBy} />
                            </Th_title>
                        </tr>
                        <tr>
                            <Th_title title={"수정일시"} colspan={1} className="fieldset-td">
                                <ReadOnlyInputBasic target={"updatedAt"} value={work.updatedAt} />
                            </Th_title>
                            <Th_title title={"수정자"} colspan={1} className="fieldset-td">
                                <ReadOnlyInputBasic target={"updatedBy"} value={work.updatedBy} />
                            </Th_title>
                        </tr>
                        <tr>
                            <Th_title title={"요청자"} colspan={3} className="fieldset-td">
                                <ReadOnlyInputBasic target={"requester"} value={work.requester} />
                            </Th_title>
                        </tr>
                        <tr className="asset-detail-kv-row--auto">
                            <Th_title title={"담당자"} colspan={3} className="fieldset-td fieldset-td-input relative align-top">
                                <DetailKvListValue items={handler} listType={KV_LIST_TYPES.user} />
                            </Th_title>
                        </tr>
                        <tr>
                            <Th_title title={"작업종류"} colspan={1} className="fieldset-td">
                                <ReadOnlyInputBasic target={"workCode"} value={work.workCode.name} />
                            </Th_title>
                            <Th_title title={"요청방식"} colspan={1} className="fieldset-td">
                                <ReadOnlyInputBasic target={"workRequest"} value={work.workRequest} />
                            </Th_title>
                        </tr>
                        <tr>
                            <Th_title title={"작업인지"} colspan={1} className="fieldset-td">
                                <ReadOnlyInputBasic target={"workAcceptCode"} value={work.workAcceptCode} />

                                <ReadOnlyInputBasic target={"workAcceptText"} value={work.workAcceptText} />
                            </Th_title>
                            <Th_title title={"작업위치"} colspan={1} className="fieldset-td">
                                <ReadOnlyInputBasic target={"location"} value={work.location} />
                            </Th_title>
                        </tr>

                        <tr>
                            <Th_title title={"작업기간"} colspan={3} className="fieldset-td fieldset-td-input">
                                <div className={"web-flex"}>
                                    <SimmsDatePicker data={work.workStartDate} readonly />
                                    <span className={cn("ml-2 mr-1 text-[20px]")}> ~ </span>
                                    <SimmsDatePicker data={work.workEndDate} readonly />
                                </div>
                            </Th_title>
                        </tr>
                        <tr>
                            <Th_title title={"작업 제목"} colspan={3} className="fieldset-td">
                                <ReadOnlyInputBasic target={"title"} value={work.title} />
                            </Th_title>
                        </tr>
                        <tr>
                            <Th_title title={"작업내용"} colspan={3} className="fieldset-td">
                                <div className={`align-text-div`}>{work.workContent}</div>
                            </Th_title>
                        </tr>
                </tbody>
            </DetailKvTable>
        </DetailPanel>
    );

    const planContentPanel = (
        <DetailPanel title={"작업계획내용"}>
            <DetailKvTable>
                <tbody>
                <tr>
                    <Th_title title={"작업기간"} colspan={3} className="fieldset-td fieldset-td-input">
                        <div className="web-flex asset-detail-date-range">
                            <SimmsDatePicker
                                onChange={(v) => dateOnChange(setWorkPlan, "workStartDate", v, false)}
                                data={workPlan.workStartDate}
                                constraint={{lessThan: workPlan.workEndDate && dayjs(workPlan.workEndDate), required: false}}
                                auth={work.auth.update}
                            />
                            <span className="asset-detail-date-range-sep">~</span>
                            <SimmsDatePicker
                                onChange={(v) => dateOnChange(setWorkPlan, "workEndDate", v, false)}
                                data={workPlan.workEndDate}
                                constraint={{largerThan: workPlan.workStartDate && dayjs(workPlan.workStartDate), required: false}}
                                auth={work.auth.update}
                            />
                        </div>
                    </Th_title>
                </tr>
                <tr className="asset-detail-kv-row--auto">
                    <Th_title title={"업무장소"} colspan={3} className="fieldset-td" auth={work.auth.update}>
                        <SimmsTextArea
                            onChange={(v) => inputOnChange(setWorkPlan, "place", v, false)}
                            data={workPlan.place}
                            style={{width: "100%", minHeight: "80px"}}
                            placeHolder={`${workPlan?.id ? "" : "데이터를 입력해주세요"}`}
                        />
                    </Th_title>
                </tr>
                <tr className="asset-detail-kv-row--auto">
                    <Th_title title={"작업근거"} colspan={3} className="fieldset-td" auth={work.auth.update}>
                        <SimmsTextArea
                            onChange={(v) => inputOnChange(setWorkPlan, "reason", v, false)}
                            data={workPlan.reason}
                            style={{width: "100%", minHeight: "80px"}}
                            placeHolder={`${workPlan?.id ? "" : "데이터를 입력해주세요"}`}
                        />
                    </Th_title>
                </tr>
                <tr className="asset-detail-kv-row--auto">
                    <Th_title title={"작업대상"} colspan={3} className="fieldset-td" auth={work.auth.update}>
                        <SimmsTextArea
                            onChange={(v) => inputOnChange(setWorkPlan, "target", v, false)}
                            data={workPlan.target}
                            style={{width: "100%", minHeight: "80px"}}
                            placeHolder={`${workPlan?.id ? "" : "데이터를 입력해주세요"}`}
                        />
                    </Th_title>
                </tr>
                <tr className="asset-detail-kv-row--auto">
                    <Th_title title={"작업내용"} colspan={3} className="fieldset-td" auth={work.auth.update}>
                        <SimmsTextArea
                            onChange={(v) => inputOnChange(setWorkPlan, "content", v, false)}
                            data={workPlan.content}
                            style={{width: "100%", minHeight: "80px"}}
                            placeHolder={`${workPlan?.id ? "" : "데이터를 입력해주세요"}`}
                        />
                    </Th_title>
                </tr>
                <tr className="asset-detail-kv-row--auto">
                    <Th_title title={"업무영향도"} colspan={3} className="fieldset-td" auth={work.auth.update}>
                        <SimmsTextArea
                            onChange={(v) => inputOnChange(setWorkPlan, "influence", v, false)}
                            data={workPlan.influence}
                            style={{width: "100%", minHeight: "80px"}}
                            placeHolder={`${workPlan?.id ? "" : "데이터를 입력해주세요"}`}
                        />
                    </Th_title>
                </tr>
                <tr className="asset-detail-kv-row--auto">
                    <Th_title title={"추가내용"} colspan={3} className="fieldset-td" auth={work.auth.update}>
                        <SimmsTextArea
                            onChange={(v) => inputOnChange(setWorkPlan, "additionalContent", v, false)}
                            data={workPlan.additionalContent}
                            style={{width: "100%", minHeight: "80px"}}
                            placeHolder={`${workPlan?.id ? "" : "데이터를 입력해주세요"}`}
                        />
                    </Th_title>
                </tr>
                <tr className="asset-detail-kv-row--auto">
                    <Th_title title={"비고"} colspan={3} className="fieldset-td" auth={work.auth.update}>
                        <SimmsTextArea
                            onChange={(v) => inputOnChange(setWorkPlan, "etc", v, false)}
                            data={workPlan.etc}
                            style={{width: "100%", minHeight: "80px"}}
                            placeHolder={`${workPlan?.id ? "" : "데이터를 입력해주세요"}`}
                        />
                    </Th_title>
                </tr>
                </tbody>
            </DetailKvTable>
        </DetailPanel>
    );

    const asidePanel = (
        <>
            <SignContainer contentId={work.id} contentCategory={"WORK"} statusNumericValue={statusNumericValue} />
            <DetailFilePanel
                title="첨부"
                isEditing={Boolean(work.auth?.update)}
                showFileLabel={false}
                tableInfo={workPlan?.id ? {tableName: "work_plan", joinKey: workPlan.id} : undefined}
                pendingFiles={workPlan?.id ? undefined : {files: docs, setFiles: setDocs}}
                pendingInputId="work_plan_pending_doc"
            />
        </>
    );

    return (
        <ContentDetailInfoShell
            title={work?.title || "작업계획서"}
            meta={summaryMeta || work?.serialNumber}
            contentId={id}
            contentCategory={ContentCategory.WORK}
            scrollMode="columns"
            trackActions
            listUrl="/maintenance/work"
            actions={<DetailSummaryPrintButton />}
            rollup={{
                cancel,
                data: work,
                remove: work.auth?.update && workPlan?.id ? remove : "",
                create: work.auth?.update && workPlan?.id ? "" : create,
                update: work.auth?.update && workPlan?.id ? update : "",
            }}
        >
            <ContentDetailThreeColLayout
                primary={requestInfoPanel}
                secondary={planContentPanel}
                aside={asidePanel}
            />
        </ContentDetailInfoShell>
    );
}

export {WorkPlanReport}